import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { db } from '../assets/firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1100,
  transition: 'opacity 0.2s ease-in-out',
};

const modalButtonStyle = {
  marginTop: '0.2rem',
  padding: '0.5rem 1rem',
  backgroundColor: '#7ebcec',
  color: 'white',
  border: 'none',
  borderRadius: '50px',
  cursor: 'pointer',
  fontWeight: 'normal',
  fontSize: '1em',
};

const ContactModal = ({ show, onClose }) => {
  const { t } = useTranslation();
  const [contactEmail, setContactEmail] = useState('');
  const [contactSubject, setContactSubject] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [contactStatus, setContactStatus] = useState('');
  useEffect(() => {
    if (!show) setContactStatus('');
  }, [show]);
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!contactEmail.trim() || !contactMessage.trim()) return;
    setContactStatus('sending');
    try {
      await addDoc(collection(db, 'mensajes'), {
        email: contactEmail.trim(),
        asunto: contactSubject.trim(),
        mensaje: contactMessage.trim(),
        fecha: serverTimestamp(),
      });
      setContactEmail('');
      setContactSubject('');
      setContactMessage('');
      setContactStatus('sent');
    } catch (err) {
      console.error('Error al enviar el mensaje:', err);
      setContactStatus('error');
    }
  };
  const currentOverlayStyle = {
    ...modalOverlayStyle,
    opacity: show ? 1 : 0,
    pointerEvents: show ? 'auto' : 'none',
  };
  const outerStyle = {
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '0.625rem',
    width: '90vw',
    maxWidth: '27rem',
    boxSizing: 'border-box',
    padding: '2.75rem 2.25rem 2.25rem',
    boxShadow: '0 0.25rem 0.625rem rgba(0, 0, 0, 0.2)',
    transform: show ? 'scale(1)' : 'scale(0.8)',
    transition: 'transform 0.2s ease-in-out',
  };
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const paragraphStyle = {
    fontFamily: 'Effra',
    fontWeight: 300,
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#4d4d4d',
    margin: 0,
  };
  const inputStyle = {
    fontFamily: 'Effra',
    fontWeight: 300,
    fontSize: '1rem',
    color: '#4d4d4d',
    padding: '0.7rem 0.9rem',
    borderRadius: '0.4rem',
    border: '1px solid #d9d9d9',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#f8f9fa',
  };
  return (
    <div style={currentOverlayStyle} onClick={handleOverlayClick}>
      <div style={outerStyle}>
        <div
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            cursor: 'pointer',
            display: 'flex',
            color: '#4d4d4d',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            style={{ width: '1.5rem', height: '1.5rem' }}
          >
            <path
              fillRule="evenodd"
              d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <h2
          style={{
            fontFamily: 'Effra',
            fontWeight: 400,
            fontSize: '1.4rem',
            margin: '0 0 0.8rem',
            color: '#4d4d4d',
          }}
        >
          {t('aboutModal.contact.title')}
        </h2>
        {contactStatus === 'sent' ? (
          <p style={{ ...paragraphStyle, color: '#3a9d5d', fontWeight: 400 }}>
            {t('aboutModal.contact.success')}
          </p>
        ) : (
          <form
            onSubmit={handleContactSubmit}
            style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem' }}
          >
            <p style={paragraphStyle}>{t('aboutModal.contact.intro')}</p>
            <input
              type="email"
              placeholder={t('aboutModal.contact.emailPlaceholder')}
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              required
              disabled={contactStatus === 'sending'}
              style={inputStyle}
            />
            <input
              type="text"
              placeholder={t('aboutModal.contact.subjectPlaceholder')}
              value={contactSubject}
              onChange={(e) => setContactSubject(e.target.value)}
              disabled={contactStatus === 'sending'}
              style={inputStyle}
            />
            <textarea
              placeholder={t('aboutModal.contact.messagePlaceholder')}
              value={contactMessage}
              onChange={(e) => setContactMessage(e.target.value)}
              required
              rows={4}
              disabled={contactStatus === 'sending'}
              style={{ ...inputStyle, resize: 'vertical', minHeight: '5rem' }}
            />
            {contactStatus === 'error' && (
              <p style={{ ...paragraphStyle, color: '#e74c3c', fontSize: '0.9rem' }}>
                {t('aboutModal.contact.error')}
              </p>
            )}
            <button
              type="submit"
              disabled={contactStatus === 'sending'}
              style={{
                ...modalButtonStyle,
                alignSelf: 'flex-start',
                cursor: contactStatus === 'sending' ? 'not-allowed' : 'pointer',
                opacity: contactStatus === 'sending' ? 0.6 : 1,
              }}
            >
              {contactStatus === 'sending'
                ? t('aboutModal.contact.sending')
                : t('aboutModal.contact.sendButton')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
